import { css } from 'styled-components';
import { colorCSS, colorContrastCSS, headingColorContrastCSS, borderColorCSS, colorExists, colorIsDark } from './colors';
import { gradientCSS, gradientContrastCSS, gradientExists, gradientIsDark } from './gradients';
export function isBackgroundFieldValue(value) {
    return !!value;
}
//background json could be { gradient: 'GR234' }
export function getColorsFromBackgroundField(background) {
    if (isBackgroundFieldValue(background)) {
        const { gradient, angle, color } = background;
        if (gradient && gradientExists(gradient)) {
            return {
                background: gradientCSS(gradient, angle),
                color: gradientContrastCSS(gradient),
                medium: gradientContrastCSS(gradient, 0.2),
                linkColor: gradientIsDark(gradient)
                    ? colorCSS('N0', 0.8)
                    : colorCSS('B400'),
                linkHoverColor: gradientIsDark(gradient)
                    ? colorCSS('N0')
                    : colorCSS('B500')
            };
        }
        else if (color && colorExists(color)) {
            return {
                background: colorCSS(color),
                color: colorContrastCSS(color),
                medium: colorContrastCSS(color, 0.2),
                headingColor: headingColorContrastCSS(color),
                borderColor: borderColorCSS(color),
                linkColor: colorIsDark(color) ? colorCSS('N0', 0.8) : colorCSS('B400'),
                linkHoverColor: colorIsDark(color) ? colorCSS('N0') : colorCSS('B500')
            };
        }
    }
    return {};
}
export function cssColorsFromBackgroundField(backgroundField) {
    if (!isBackgroundFieldValue(backgroundField)) {
        return null;
    }
    const { background, color, linkColor, linkHoverColor } = getColorsFromBackgroundField(backgroundField);
    const bgProperty = backgroundField.gradient
        ? 'background'
        : 'background-color';
    return css `
    ${bgProperty}: ${background};
    color: ${color};
    a {
      color: ${linkColor};
      &:hover {
        color: ${linkHoverColor};
      }
    }
    *:focus {
      outline: 2px solid ${color};
      &:not(:focus-visible) {
        outline: 0 !important;
      }
    }
  `;
}
//# sourceMappingURL=background.js.map